import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { GoogleMap, useLoadScript, Marker, InfoWindow } from '@react-google-maps/api';
import { Table, Button, Select, Input } from 'antd';
import { ComponentToPrint } from './Print';
import { toast } from 'react-toastify';
import ReactToPrint from 'react-to-print';
import 'react-toastify/dist/ReactToastify.css';
import '../pesquisarcontador.css';

toast.configure();

const { Option } = Select;

const center = {
  lat: -25.948160546759134,
  lng: 32.58577582313654
};

const estilo = {
  disableDefaultUI: true,
  zoomControl: true
};

function Pesquisarcontador() {
  const [data, setData] = useState({ nrcontador: "" });
  const [re, setRe] = useState(null);
  const [actualiza, setActualiza] = useState(null);
  const [ma, setMa] = useState(null);
  const [r2e, set2Re] = useState(null);
  const [us, setUs] = useState([]);
  const componentPrint = useRef(null);
  const componentPrints = useRef(null);
  const [selecionado, setSelecionado] = useState(null);
  const [error, setError] = useState();
  const mapRef = useRef(null);

  const mapContainerStyle = {
    width: "100%",
    height: `50vh`,
  };

  const Handle = () => {
    axios({
      method: "post",
      url: `${localStorage.getItem('url')}/web/vercounter/`,
      headers: { 'Authorization': `token ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
      data: data
    }).then(dat => {
      if (dat.status !== 200) {
        throw Error('Dados de acesso inválidos');
      }
      return dat;
    }).then(d => {
      console.log(d.data);
      setUs(d.data);
      setRe("ola");
    }).catch(e => {
      setError(e.message);
    });
  };

  const Tokens_lista = () => {
    set2Re(null);
    setActualiza(null);
    axios({
      method: "post",
      url: `${localStorage.getItem('url')}/web/TokensContador/`,
      headers: { 'Authorization': `token ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
      data: { id: data.nrcontador }
    }).then(dat => {
      if (dat.status !== 200) {
        throw Error('Dados de acesso inválidos');
      }
      return dat;
    }).then(d => {
      console.log(d.data);
      setMa(d.data);
    }).catch(e => {
      setError(e.message);
    });
  };

  const TerInfo = () => {
    setActualiza('dfdf');
  };

  const Historico = () => {
    axios({
      method: "post",
      url: `${localStorage.getItem('url')}/web/ContadoravariaS/`,
      headers: { 'Authorization': `token ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
      data: { id: data.nrcontador }
    }).then(dat => {
      if (dat.status !== 200) {
        throw Error('Dados de acesso inválidos');
      }
      return dat;
    }).then(d => {
      console.log(d.data);
      set2Re(d.data);
    }).catch(e => {
      setError(e.message);
    });
  };

  const Send = e => {
    e.preventDefault();
  };

  const MHandler = e => {
    e.preventDefault();
    setMa(null);
    set2Re(null);
    TerInfo();
  };

  const HandleT = e => {
    e.preventDefault();
    Tokens_lista();
  };

  const HHandler = e => {
    e.preventDefault();
    setMa(null);
    setActualiza(null);
    Historico();
  };

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "YOUR_API_KEY_HERE",
  });

  useEffect(() => {
    localStorage.setItem('seight', mapRef.current.offsetHeight);
    mapContainerStyle.height = `${Math.abs(`${Math.abs(`${localStorage.getItem('mainheig')}` - `${localStorage.getItem('minheight')}`)}` - `${localStorage.getItem('seight')}`)}px`;
  }, []);

  return (
    <div className='PesquisaContador'>
      <div className='search' ref={mapRef}>
        <div style={{color:'black'}}>Numero do Contador</div>
        <div id="ps"> <Input onChange={e => setData({ ...data, nrcontador: e.target.value })} value={data.nrcontador} required suffix={  <Button  onClick={Handle}>Pesquisar</Button>} /></div>
     
      </div>

      {re && <div id='toolbar'>
        <img id="imagem" src={require('./images/payment.png')} />
        <Button id="opcao" onClick={Tokens_lista}>Tokens</Button>
        <img id="imagem" src={require('./images/update.png')} />
        <Button id="opcao" onClick={MHandler}>Actualizar Dados</Button>
        <img id="imagem" src={require('./images/exclamation-mark.png')} />
        <Button id="opcao" onClick={HHandler}>Historico</Button>
      </div>}

      {ma && <div className='tokensf'>
        <Table dataSource={ma} rowKey={(record) => record.id}>
          <Table.Column title="Nome do Cliente" dataIndex="nome" />
          <Table.Column title="Numero de Contador" dataIndex="numero_do_contador" />
          <Table.Column title="Token" dataIndex="numero_token" />
          <Table.Column title="Tipo" dataIndex="tipo" />
          <Table.Column title="Estado" dataIndex="estado" />
          <Table.Column title="Morada" dataIndex="morada" />
          <Table.Column title="TID" dataIndex="tid" />
        </Table>

        <img id="imagem" src={require('./images/printer.png')} />
        <ReactToPrint
          trigger={() => <Button id="opcao" onClick={Send}>Imprimir</Button>}
          content={() => componentPrint.current}
        />
        <Button id="opcao" onClick={() => setMa(null)}>Fechar</Button>
      </div>}

      {r2e && <div className='tokensf'>
        <Table dataSource={r2e} rowKey={(record) => record.id}>
          <Table.Column title="Numero do contador" dataIndex="numero_do_contador" />
          <Table.Column title="Codigo de Erro" dataIndex="diagnostco_tecnico" />
          <Table.Column title="Descricao da Falha" dataIndex="descricao" />
          <Table.Column title="Necessidade de Operario" dataIndex="Necesse" />
          <Table.Column title="Estado" dataIndex="Estado" />
          <Table.Column title="Imagem" dataIndex="foto" />
          <Table.Column title="Data De Submissao" dataIndex="datahora" />
        </Table>

        <img id="imagem" src={require('./images/printer.png')} />
        <ReactToPrint
          trigger={() => <Button id="opcao" onClick={Send}>Imprimir</Button>}
          content={() => componentPrints.current}
        />
        <Button id="opcao" onClick={() => set2Re(null)}>Fechar</Button>
      </div>}

      {actualiza && <div className='Actualizaf'>
        <div>Chaves STS</div>
        <Select id="combos" maxMenuHeight={250} onChange={(e) => { const provincia = e; }}>
          <Option value='sdsd'>05,01M,DUTK,670610</Option>
          <Option value='sdsd'>06,02M,DUTK,650610</Option>
          <Option value='sdsd'>07,03M,DUTK,640610</Option>
        </Select>
        <div>TID</div>
        <Select id="combos" maxMenuHeight={250} onChange={(e) => { const provincia = e; }}>
          <Option value='sdsd'>2014</Option>
          <Option value='sdsd'>1993</Option>
        </Select>
        <Button id="opcao" onClick={() => { toast.success('actualizado com sucesso!'); setActualiza(null); }}>Actualizar</Button>
      </div>}

      {re && <div className='Conter'>
        <div className='mts'>
          <GoogleMap mapContainerStyle={mapContainerStyle} zoom={7} center={center} options={estilo}>
            {us.map((marker) => (
              <Marker key={marker.id} position={{ lat: parseFloat(marker.lat), lng: parseFloat(marker.lon) }} icon={{ url: '/meter.png' }} onClick={() => { setSelecionado(marker); }} />
            ))}
            {selecionado && (
              <InfoWindow position={{ lat: parseFloat(selecionado.lat), lng: parseFloat(selecionado.lon) }} onCloseClick={() => { setSelecionado(null); }}>
                <div>
                  <h4>{selecionado.nome}</h4>
                  <p>BI: {selecionado.bi}</p>
                  <p>Morada: {selecionado.morada}</p>
                  <p>Email: {selecionado.email}</p>
                  <p>Telemovel: {selecionado.telemovel}</p>
                  <p>Data de Instalacao: {selecionado.data_desinstalacao}</p>
                </div>
              </InfoWindow>
            )}
          </GoogleMap>
        </div>
      </div>}


    </div>
  );
}

export default Pesquisarcontador;
